<template>
  <div style="height: 100%" class="pa-4">
    <application-notification :show="!getUser.prompted" text="Ensure to provide accurate Scratch card details details in this section. Kindly note that editing will not be allowed"></application-notification>
    <v-form ref="form" v-model="dataValid">
      <div class="error pa-4 white--text rounded-lg mb-4">
        Make sure you enter the card information correctly, since any changes will be rejected. It is also worth noting that supplying incorrect information may result in your disqualification.
      </div>
      <v-form v-model="dataValid">
        <v-sheet  v-for="(item, index) in getSSCEDetails" :key="item.id" class="mb-2 mt-4 rounded-lg">
          <div class="d-flex justify-space-between py-2">
            <div class="my-auto ml-4 font-weight-bold">
              {{item.organization.title}} - {{item.examType.title}}
            </div>
          </div>
          <v-row class="px-4">
            <v-col cols="12" sm="12" md="6">
              <v-text-field :rules="textRules" dense :disabled="hasScratchCards" label="Card Pin" v-model="cards[index].pin"></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-text-field dense :disabled="hasScratchCards" label="Card Serial number" v-model="cards[index].serialNumber"></v-text-field>
            </v-col>
          </v-row>
        </v-sheet>
      </v-form>
    </v-form>
    <v-card-actions class="mt-6">
      <v-btn color="basic" width="10em" class="white--text" @click="$emit('back')" depressed>{{  noHeader ? 'Back' : "Previous" }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn
          color="primaryLight"
          width="10em"
          depressed
          :disabled="!dataValid || hasScratchCards"
          @click="process"
          v-if="!hasScratchCards"
          :loading="loading"
          style="color: #FFFFFF"
      ><v-icon>mdi-content-save</v-icon>{{  noHeader ? 'Save' : 'Proceed' }}</v-btn>
      <v-btn
          color="info"
          depressed
          width="10em"
          @click="success"
          v-if="hasScratchCards"
      >Skip</v-btn
      >
    </v-card-actions>
    <loading-dialog :show="loading"></loading-dialog>
    <message-box
        :show="messageShow"
        :message="message"
        :type="messageType"
        v-on:close-message="messageShow = !messageShow"
    ></message-box>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Api from "@/main/api";
import ErrorResolver from "@/shared/ErrorResolver";
import MessageBox from "@ui/components/MessageBox";
import ValidationRules from "@/shared/ValidationRules";
import LoadingDialog from "@ui/components/LoadingDialog";
import ApplicationNotification from "@/application/pages/lafia/components/ApplicationNotification.vue";

export default {
  name: "ScratchCardManual",
  props: {
    noHeader: Boolean
  },
  components: {ApplicationNotification, LoadingDialog, MessageBox},
  data: () => ({
    dataValid: true,
    messageType: "",
    message: "",
    messageShow: false,
    loading: false,
    textRules: ValidationRules.textRules,
    cards: []
  }),

  methods: {
    success() {
      this.$emit("success");
    },

    process(){
      if(this.getUser == null)
        return

      this.loading = true;
      let fd = new FormData();
      // copy required
      let d = [];
      for (let i = 0; i < this.cards.length; i++) d.push(this.cards[i]);

      const json = JSON.stringify(d);
      const blob = new Blob([json], {
        type: "application/json",
      });

      fd.append("cards", blob);
      fd.append("applicant", this.getUser.id)
      Api.scratchCard.updateNew(fd)
          .then(res => {
            this.messageType = "success"
            this.message = "Details uploaded"
            this.messageShow = true
            // update state
            this.$store.commit("setScratchCards", res.data);

            // reload
            window.location.reload()
          }).catch(err => ErrorResolver.checkErrors(this, err))
          .finally(this.loading = false)
    }
  },

  computed: {
    ...mapGetters(["getScratchCards", "getSSCEDetails", "getUser"]),

    hasScratchCards: function(){
      return this.getScratchCards.length === this.getSSCEDetails.length
      // return true
    }
  },

  watch: {
    getSSCEDetails: function(val){
      if(val != null){
        this.cards = []
        if(val.length > 0){
          for (let i = 0; i < val.length; i++){
            this.cards.push({
              ssce: val[i].id,
              pin: val[i].scratchCardPin,
              serialNumber: val[i].scratchCardSerialNumber
            })
          }
        }
      }
    }
  },

  created() {
    if(this.getSSCEDetails.length > 0){
      for (let i = 0; i < this.getSSCEDetails.length; i++){
        this.cards.push({
          ssce: this.getSSCEDetails[i].id,
          pin: this.getSSCEDetails[i].scratchCardPin,
          serialNumber: this.getSSCEDetails[i].scratchCardSerialNumber
        })
      }
    }

    this.noHeader && this.$emit('update-title', "Scratch cards")
  }
}
</script>

<style scoped>
.v-text-field >>> .v-input__slot::before  { border-color: #ECBD44 !important; border-width: .01em; border-radius: .006em; }
</style>
